export enum AuctionMemberPageStatus {
  /**
   * 待发布
   */
  WAIT_PUBLISH = 0,

  /**
   * 待审核
   */
  WAIT_AUDIT = 1,

  /**
   * 审核不通过
   */
  AUDIT_FAIL = 2,

  /**
   * 待开始
   */
  WAIT_START = 3,

  /**
   * 竞价中
   */
  BIDDING = 4,

  /**
   * 待委托方确认
   */
  WAIT_ENTRUST_CONFIRM = 5,

  /**
   * 待参与方确认
   */
  WAIT_PARTICIPANT_CONFIRM = 6,

  /**
   * 委托方已确认
   */
  ENTRUST_CONFIRMED = 7,

  /**
   * 已成交
   */
  DEAL = 8,

  /**
   * 部分成交
   */
  DEAL_PART = 9,

  /**
   * 未成交
   */
  DEAL_FAIL = 10,

  /**
   * 委托方终止交易
   */
  ENTRUST_HALT = 11,

  /**
   * 终止未通过
   */
  HALT_FAIL = 12,

  /**
   * 已终止
   */
  HALT_SUCCESS = 13
}

export const AuctionMemberPageStatusColorMap = {
  [AuctionMemberPageStatus.WAIT_PUBLISH]: 'default',
  [AuctionMemberPageStatus.WAIT_AUDIT]: 'default',
  [AuctionMemberPageStatus.AUDIT_FAIL]: 'default',
  [AuctionMemberPageStatus.WAIT_START]: 'default',
  [AuctionMemberPageStatus.BIDDING]: 'processing',
  [AuctionMemberPageStatus.WAIT_ENTRUST_CONFIRM]: 'processing',
  [AuctionMemberPageStatus.WAIT_PARTICIPANT_CONFIRM]: 'processing',
  [AuctionMemberPageStatus.ENTRUST_CONFIRMED]: 'processing',
  [AuctionMemberPageStatus.DEAL]: 'success',
  [AuctionMemberPageStatus.DEAL_PART]: 'success',
  [AuctionMemberPageStatus.DEAL_FAIL]: 'default',
  [AuctionMemberPageStatus.ENTRUST_HALT]: 'warning',
  [AuctionMemberPageStatus.HALT_FAIL]: 'default',
  [AuctionMemberPageStatus.HALT_SUCCESS]: 'default'
}

/**
 * 委托方看到的状态说明
 */
export const AuctionMemberPageStatusEntrustTextMap = {
  [AuctionMemberPageStatus.WAIT_PUBLISH]: '待发布',
  [AuctionMemberPageStatus.WAIT_AUDIT]: '待审核',
  [AuctionMemberPageStatus.AUDIT_FAIL]: '审核不通过',
  [AuctionMemberPageStatus.WAIT_START]: '待开始',
  [AuctionMemberPageStatus.BIDDING]: '竞价中',
  [AuctionMemberPageStatus.WAIT_ENTRUST_CONFIRM]: '待确认',
  [AuctionMemberPageStatus.WAIT_PARTICIPANT_CONFIRM]: '待参与方确认',
  [AuctionMemberPageStatus.ENTRUST_CONFIRMED]: '已确认',
  [AuctionMemberPageStatus.DEAL]: '已成交',
  [AuctionMemberPageStatus.DEAL_PART]: '部分成交',
  [AuctionMemberPageStatus.DEAL_FAIL]: '未成交',
  [AuctionMemberPageStatus.ENTRUST_HALT]: '终止中',
  [AuctionMemberPageStatus.HALT_FAIL]: '终止未通过',
  [AuctionMemberPageStatus.HALT_SUCCESS]: '交易已终止'
}

/**
 * 参与方看到的状态说明
 */
export const AuctionMemberPageStatusParticipantTextMap = {
  [AuctionMemberPageStatus.WAIT_PUBLISH]: '待发布',
  [AuctionMemberPageStatus.WAIT_AUDIT]: '待审核',
  [AuctionMemberPageStatus.AUDIT_FAIL]: '审核不通过',
  [AuctionMemberPageStatus.WAIT_START]: '待开始',
  [AuctionMemberPageStatus.BIDDING]: '进行中',
  [AuctionMemberPageStatus.WAIT_ENTRUST_CONFIRM]: '待委托方确认',
  [AuctionMemberPageStatus.WAIT_PARTICIPANT_CONFIRM]: '待确认',
  [AuctionMemberPageStatus.ENTRUST_CONFIRMED]: '委托方已确认',
  [AuctionMemberPageStatus.DEAL]: '已成交',
  [AuctionMemberPageStatus.DEAL_PART]: '部分成交',
  [AuctionMemberPageStatus.DEAL_FAIL]: '未成交',
  [AuctionMemberPageStatus.ENTRUST_HALT]: '委托方申请终止',
  [AuctionMemberPageStatus.HALT_FAIL]: '终止未通过',
  [AuctionMemberPageStatus.HALT_SUCCESS]: '交易已终止'
}
